"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IconBase = require("../IconBase");

var _utils = require("../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var iconBase = {
  width: 16,
  height: 16
};

var Delete = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(Delete, _PureComponent);

  function Delete() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = Delete.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        color = _this$props.color,
        size = _this$props.size,
        block = _this$props.block;
    var newSize = (0, _utils.calcIconSize)(iconBase, size);
    return _react2.default.createElement(_IconBase.Svg, {
      name: "delete",
      size: newSize,
      block: block
    }, _react2.default.createElement("path", {
      d: "M2 0H0V6H2V0Z",
      transform: "translate(5 7)",
      fill: color
    }), _react2.default.createElement("path", {
      d: "M2 0H0V6H2V0Z",
      transform: "translate(9 7)",
      fill: color
    }), _react2.default.createElement("path", {
      d: "M12 1C12 0.4 11.6 0 11 0H5C4.4 0 4 0.4 4 1V3H0V5H1V15C1 15.6 1.4 16 2 16H14C14.6 16 15 15.6 15 15V5H16V3H12V1ZM6 2H10V3H6V2ZM13 5V14H3V5H13Z",
      fill: color
    }));
  };

  return Delete;
}(_react.PureComponent);

Delete.defaultProps = {
  color: 'currentColor',
  size: 16,
  block: false
};
Delete.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.number,
  block: _propTypes2.default.bool
};
exports.default = Delete;